module.exports = __webpack_public_path__ + "assets/retina_LDivide3Detailed.2fbde83bd2b19a3508f0d7f8aa51ca98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LDivide3Detailed.png
// module id = 683
// module chunks = 0